export default __webpack_public_path__ + "static/media/generateinvoices.91225561.webp";